import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import './Location.css';

// Fix for default icon issues with React-Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const Location = () => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Fade out after 7 seconds (7000ms)
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 7000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="location-page">
      <div className="video-banner">
        <video autoPlay loop muted playsInline className="banner-video">
          <source src="/video/vhome2023.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <section className={`venue-card-overlay ${isVisible ? 'visible' : 'faded'}`}>
          <h2 className="page-title" style={{ color: 'var(--text-primary)', marginBottom: '15px' }}>Crondon Park</h2>
          <p className="subtitle" style={{ 
            fontSize: 'clamp(1.1rem, 3vw, 1.3rem)',
            color: 'var(--text-primary)',
            marginBottom: '20px',
            fontStyle: 'italic',
            fontFamily: 'var(--font-body)',
            fontWeight: '400'
          }}>Historic Wedding Venue in Stock, Essex</p>
          <p style={{
            fontSize: 'clamp(0.95rem, 2.5vw, 1.1rem)',
            lineHeight: '1.8',
            color: 'var(--text-primary)',
            fontFamily: 'var(--font-body)',
            maxWidth: '700px',
            margin: '0 auto',
            fontWeight: '400'
          }}>
            Crondon Park is a 17th-century venue nestled in the countryside, blending timeless charm with elegant, modern comforts. 
            It features the Baronial Hall and Ryder Room, ideal for both ceremonies and celebrations.
          </p>
        </section>
      </div>

      <div className="page-container" style={{ paddingTop: '20px' }}>

        <section className="venue-layout">
          <div className="venue-map">
            <MapContainer center={[51.6626, 0.4328]} zoom={15} style={{ height: '100%', width: '100%' }}>
              <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              />
              <Marker position={[51.6626, 0.4328]}>
                <Popup>Crondon Park<br />Where Kerry becomes a Stow!</Popup>
              </Marker>
            </MapContainer>
          </div>
          <aside className="venue-contact">
            <h3 style={{
              fontFamily: 'var(--font-heading)',
              fontSize: 'clamp(1.2rem, 3vw, 1.5rem)',
              marginBottom: '15px',
              color: 'var(--text-dark)',
              textAlign: 'center',
              fontWeight: '600',
              textTransform: 'uppercase',
              letterSpacing: '0.5px'
            }}>Venue Details</h3>
            <div style={{ textAlign: 'left' }}>
              <p style={{
                fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
                lineHeight: '1.8',
                marginBottom: '15px',
                fontFamily: 'var(--font-body)',
                color: 'var(--text-dark-secondary)'
              }}>
                <strong style={{ display: 'block', marginBottom: '5px', color: 'var(--text-dark)' }}>Address:</strong>
                <a href="https://www.google.com/maps/place/Crondon+Park/@51.6772791,0.4420335,17z" target="_blank" rel="noopener noreferrer" style={{
                  color: 'var(--link-color)',
                  textDecoration: 'none'
                }}>
                  Stock Road, Stock, Essex CM4 9DP
                </a>
              </p>
              <p style={{
                fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
                lineHeight: '1.8',
                marginBottom: '15px',
                fontFamily: 'var(--font-body)',
                color: 'var(--text-dark-secondary)'
              }}>
                <strong style={{ display: 'block', marginBottom: '5px', color: 'var(--text-dark)' }}>Phone:</strong>
                01277 841115 (General)<br />
                01277 843034 (Events)
              </p>
              <p style={{
                fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
                lineHeight: '1.8',
                marginBottom: '15px',
                fontFamily: 'var(--font-body)',
                color: 'var(--text-dark-secondary)'
              }}>
                <strong style={{ display: 'block', marginBottom: '5px', color: 'var(--text-dark)' }}>Email:</strong>
                <a href="mailto:info@crondon.com" style={{
                  color: 'var(--link-color)',
                  textDecoration: 'none'
                }}>info@crondon.com</a>
              </p>
              <p style={{ textAlign: 'center', marginTop: '20px' }}>
                <a 
                  href="https://www.crondonpark.com/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="button-primary"
                  style={{
                    fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
                    textDecoration: 'none',
                    display: 'inline-block'
                  }}
                >
                  Visit Website
                </a>
              </p>
            </div>
          </aside>
        </section>
      </div>
    </div>
  );
};

export default Location;